/**
 * 公共路由配置
 * 这些路由不需要菜单权限即可访问
 */

import { MenuListItem } from '@/store/modules/menu/index'

/**
 * 不需要菜单权限的公共路由列表
 */
export const publicRoutes: MenuListItem[] = [
  {
    routeUrl: '/portal/base/system/problemFeedBack',
    localKey: 'base.menu.problemFeedback',
    name: '问题反馈'
  },
  {
    routeUrl: '/portal/base/system/downloadCenter',
    localKey: 'base.menu.downloadCenter',
    name: '下载中心'
  }
  // 可以在这里添加其他不需要菜单权限的路由
  // {
  //   routeUrl: '/portal/other/public-route',
  //   localKey: 'base.menu.otherRoute'
  //   name: '菜单名称',
  // }
]

/**
 * 检查路由是否为公共路由（不需要菜单权限）
 * @param path 路由路径
 * @returns 如果是公共路由返回 MenuListItem 格式的配置，否则返回 null
 */
export const isPublicRoute = (path: string): MenuListItem | null =>
  publicRoutes.find(r => r.routeUrl === path) ?? null
